/** Help Guide strings for non-English locales (en base lives in translations.js). */

export const HELP_GUIDE_COMMON_LABELS = {
  hi: "सहायता गाइड",
  pa: "ਸਹਾਇਤਾ ਗਾਈਡ",
  te: "సహాయ గైడ్",
  ta: "உதவி வழிகாட்டி",
  mr: "मदत मार्गदर्शक",
  bn: "সহায়তা গাইড",
  kn: "ಸಹಾಯ ಮಾರ್ಗದರ್ಶಿ",
};

export const HI_HELP_GUIDE = {
  subtitle: "अक्सर पूछे जाने वाले प्रश्न • सुझाव • सहायता",
  subtitleFaq: "अक्सर पूछे जाने वाले प्रश्न",
  subtitleTips: "सुझाव",
  subtitleSupport: "सहायता",
  searchPlaceholder: "सहायता लेख खोजें...",
  categories: "श्रेणियाँ",
  categoryAll: "सभी",
  categoryDailyHealth: "डैशबोर्ड और वाइटल्स",
  categoryAiAssistant: "तारा AI चैट",
  categorySecurity: "रिकॉर्ड और दवाएँ",
  welcomeTitle: "myTara सहायता केंद्र में आपका स्वागत है",
  welcomeDesc:
    "डैशबोर्ड, वाइटल्स, तारा AI चैट, दवाएँ, रिपोर्ट, मेड क्लाउड, परिवार प्रोफ़ाइल, कॉइन, कैलेंडर और खाता सेटिंग्स के लिए पूर्ण मार्गदर्शिकाएँ।",
  dailyHealthTitle: "डैशबोर्ड और लाइव वाइटल्स",
  dailyHealthSubtitle: "रीयल-टाइम वाइटल्स, चार्ट और वेलनेस टूल्स के साथ आपका दैनिक स्वास्थ्य केंद्र",
  dailyHealthStep1: "साइडबार से डैशबोर्ड खोलें — अभिवादन, वाइटल्स कार्ड और स्वास्थ्य आँकड़े देखें",
  dailyHealthStep2: "लाइव सॉकेट अपडेट के साथ ब्लड प्रेशर, हृदय गति, ग्लूकोज और SpO₂ की निगरानी करें",
  dailyHealthStep3: "डैशबोर्ड पर BP, हृदय गति, ग्लूकोज और ऑक्सीजन चार्ट के बीच स्विच करें",
  dailyHealthStep4: "डैशबोर्ड की दवा अनुभाग से सीधे दवाएँ ली हुई चिह्नित करें",
  dailyHealthStep5: "अपनी स्वास्थ्य प्रोफ़ाइल के लिए सुझाए गए फिटनेस और वेलनेस वीडियो देखें",
  dailyHealthStep6: "कॉइन कमाने और ट्रैक पर रहने के लिए डैशबोर्ड पर दैनिक मिशन पूरे करें",
  dailyHealthTip: "सुझाव: कम SpO₂ जैसी वाइटल्स चेतावनियों के लिए हर सुबह डैशबोर्ड जाँचें",
  vitalsReportsTitle: "वाइटल्स रिपोर्ट",
  vitalsReportsSubtitle: "समय के साथ रुझान, इतिहास और विस्तृत रीडिंग देखें",
  vitalsReportsBullet1: "ऐतिहासिक स्वास्थ्य डेटा के लिए साइडबार से वाइटल्स रिपोर्ट खोलें",
  vitalsReportsBullet2: "BP, HR, ग्लूकोज और SpO₂ में पैटर्न पहचानने के लिए तारीखों में रीडिंग तुलना करें",
  vitalsReportsBullet3: "डॉक्टर या परिवार के देखभालकर्ता के साथ रुझान पर चर्चा करते समय रिपोर्ट का उपयोग करें",
  vitalsReportsBullet4: "क्विक हेल्थ एक्शन से हाल की वाइटल्स का सारांश पाने के लिए तारा चैट में पूछें",
  calendarTitle: "कैलेंडर और अपॉइंटमेंट",
  calendarSubtitle: "विज़िट शेड्यूल करें और आगामी स्वास्थ्य कार्यक्रमों पर नज़र रखें",
  calendarBullet1: "अपॉइंटमेंट देखने और प्रबंधित करने के लिए साइडबार से कैलेंडर खोलें",
  calendarBullet2: "नई अपॉइंटमेंट बुक करें और जरूरत पड़ने पर मौजूदा विज़िट पुनर्निर्धारित करें",
  calendarBullet3: "आगामी विज़िट तुरंत देखने के लिए तारा चैट क्विक पिक्स → अपॉइंटमेंट का उपयोग करें",
  calendarBullet4: "अपॉइंटमेंट से पहले परिवार के सदस्यों के लिए स्वास्थ्य प्रश्नावली पूरी करें",
  calendarTip: "सुझाव: डॉक्टर को पूरा संदर्भ मिले, इसलिए स्वास्थ्य प्रश्नावली जल्दी भरें",
  coinsTitle: "कॉइन, रिवार्ड और मिशन",
  coinsSubtitle: "स्वस्थ आदतों के लिए कॉइन कमाएँ और रिवार्ड रिडीम करें",
  coinsBullet1: "लॉगिन के बाद हेडर के नीचे रिवार्ड स्ट्रिप में अपना कॉइन बैलेंस देखें",
  coinsBullet2: "हर लॉगिन पर +1 कॉइन और दैनिक मिशन पूरे करके और कमाएँ",
  coinsBullet3: "कॉइन वॉलेट पेज खोलने के लिए बैलेंस या रिडीम पर टैप करें",
  coinsBullet4: "रिवार्ड बैलेंस बढ़ाने के लिए डैशबोर्ड और वॉलेट मिशन पूरे करें",
  aiTitle: "तारा AI चैट और क्विक पिक्स",
  aiSubtitle: "सामान्य कार्यों के लिए स्मार्ट शॉर्टकट के साथ 24/7 स्वास्थ्य सहायक",
  aiBullet1: "तारा खोलकर स्वास्थ्य प्रश्न पूछने के लिए चैट बबल (नीचे-दाएँ) पर टैप करें",
  aiBullet2: "क्विक पिक्स: लक्षण जाँचें, वाइटल रिपोर्ट, दवा, रिपोर्ट, स्वास्थ्य सारांश",
  aiBullet3: "क्विक पिक्स में तेज़ नेविगेशन के लिए परिवार सदस्य और अपॉइंटमेंट भी शामिल हैं",
  aiBullet4: "लक्षण और रिपोर्ट विश्लेषण के लिए चैट में वॉइस, टेक्स्ट या फ़ाइल अपलोड का उपयोग करें",
  aiBullet5: "होम पेज पर अतिथि उपयोगकर्ता भी पंजीकरण से पहले तारा से चैट कर सकते हैं",
  taraGuideTitle: "तारा गाइड साइड पैनल",
  taraGuideSubtitle: "ऐप ब्राउज़ करते समय संदर्भित AI मार्गदर्शन",
  taraGuideBullet1: "myTara उपयोग करते समय तारा गाइड पैनल दाईं ओर खुला रहता है",
  taraGuideBullet2: "कम SpO₂ चेतावनियों और व्यक्तिगत सुझाव जैसी स्वास्थ्य अलर्ट प्राप्त करें",
  taraGuideBullet3: "तारा के संदेश पढ़ें और पैनल में टेक्स्ट या वॉइस इनपुट से जवाब दें",
  taraGuideBullet4: "निरंतर स्वास्थ्य सहायता के लिए मुख्य चैट के साथ-साथ इसका उपयोग करें",
  myTaraReportsTitle: "MyTara रिपोर्ट और AI सारांश",
  myTaraReportsSubtitle: "AI-जनित चैट सारांश और स्वास्थ्य वार्तालाप लॉग",
  myTaraReportsBullet1: "AI चैट सारांश के लिए साइडबार में रिपोर्ट → MyTara रिपोर्ट पर जाएँ",
  myTaraReportsBullet2: "तारा द्वारा जनित पिछली बातचीत और स्वास्थ्य अंतर्दृष्टि की समीक्षा करें",
  myTaraReportsBullet3: "विस्तृत सत्र इतिहास के लिए व्यक्तिगत सारांश लॉग खोलें",
  myTaraReportsBullet4: "त्वरित वेलनेस अवलोकन के लिए चैट में हेल्थ सारांश क्विक पिक का उपयोग करें",
  familyTitle: "परिवार खोज और प्रोफ़ाइल",
  familySubtitle: "परिवार के सदस्यों का प्रबंधन करें और स्वास्थ्य प्रोफ़ाइल बदलें",
  familyBullet1: "सदस्य जोड़ने या संपादित करने के लिए साइडबार से परिवार खोज खोलें",
  familyBullet2: "हेडर प्रोफ़ाइल ड्रॉपडाउन से स्वयं और परिवार प्रोफ़ाइल के बीच स्विच करें",
  familyBullet3: "प्रत्येक परिवार सदस्य के अपने वाइटल्स, दवाएँ और रिपोर्ट हो सकते हैं",
  familyBullet4: "नई परिवार प्रोफ़ाइल पर स्विच करते समय स्वास्थ्य प्रश्नावली पूरी करें",
  medicationTitle: "दवा और रिमाइंडर",
  medicationSubtitle: "नुस्खे, खुराक ट्रैक करें और दवा कभी न चूकें",
  medicationBullet1: "सभी सक्रिय नुस्खे देखने के लिए साइडबार से दवा खोलें",
  medicationBullet2: "खुराक समय के साथ नई दवाएँ जोड़ें और प्रत्येक शेड्यूल के लिए रिमाइंडर सक्षम करें",
  medicationBullet3: "डैशबोर्ड या दवा विवरण पेज से खुराक ली हुई चिह्नित करें",
  medicationBullet4: "नुस्खे तुरंत जाँचने के लिए तारा चैट क्विक पिक → दवा का उपयोग करें",
  medicationTip: "सुझाव: बेहतर नियमितता के लिए भोजन के समय पर रिमाइंडर सेट करें",
  medCloudTitle: "मेड क्लाउड स्टोरेज",
  medCloudSubtitle: "नुस्खे, लैब रिपोर्ट और चिकित्सा दस्तावेज़ सुरक्षित रूप से संग्रहीत करें",
  medCloudBullet1: "स्वास्थ्य फ़ाइलें अपलोड और व्यवस्थित करने के लिए साइडबार से मेड क्लाउड खोलें",
  medCloudBullet2: "नुस्खे, लैब परिणाम, स्कैन और अन्य चिकित्सा दस्तावेज़ संग्रहीत करें",
  medCloudBullet3: "अपलोड की गई फ़ाइलें कभी भी उसी मेड क्लाउड पेज से एक्सेस करें",
  medCloudBullet4: "AI-संचालित रिपोर्ट समझ के लिए तारा चैट के साथ दस्तावेज़ साझा करें",
  medicalReportsTitle: "चिकित्सा रिपोर्ट",
  medicalReportsSubtitle: "अपने आधिकारिक स्वास्थ्य रिकॉर्ड देखें, डाउनलोड करें और प्रबंधित करें",
  medicalReportsBullet1: "अपने स्वास्थ्य रिकॉर्ड के लिए साइडबार में रिपोर्ट → चिकित्सा रिपोर्ट पर जाएँ",
  medicalReportsBullet2: "लैब रिपोर्ट, नुस्खे और क्लिनिकल दस्तावेज़ एक जगह देखें",
  medicalReportsBullet3: "डॉक्टर या विशेषज्ञ से मिलने पर रिपोर्ट डाउनलोड या साझा करें",
  medicalReportsBullet4: "रिकॉर्ड तेज़ी से खोलने के लिए तारा चैट में रिपोर्ट क्विक पिक का उपयोग करें",
  accountTitle: "खाता, प्रोफ़ाइल और ऐप सेटिंग्स",
  accountSubtitle: "हेडर टूल्स, सुरक्षा, भाषा, थीम और सूचनाएँ",
  accountBullet1: "प्रोफ़ाइल मेनू: क्रेडेंशियल अपडेट, स्वास्थ्य रुचियाँ और लॉगआउट",
  accountBullet2: "myTara अनुभव को व्यक्तिगत बनाने के लिए लॉगिन के बाद स्वास्थ्य रुचियाँ चुनें",
  accountBullet3: "घंटी आइकन सूचनाएँ दिखाता है; भाषा चयनकर्ता ऐप भाषा बदलता है",
  accountBullet4: "हेडर में ? सहायता गाइड, फुलस्क्रीन टॉगल और लाइट/डार्क थीम स्विच",
  accountBullet5: "ब्राउज़र सत्रों में साइन इन रहने के लिए रिमेंबर मी के साथ लॉगिन करें",
  accountBullet6: "प्रोफ़ाइल या परिवार पेज से प्रारंभिक स्वास्थ्य प्रश्नावली पूरी करें",
  accountTip: "सुझाव: AI सुझावों को बेहतर बनाने के लिए प्रोफ़ाइल मेनू से कभी भी स्वास्थ्य रुचियाँ अपडेट करें",
  faqTitle: "अक्सर पूछे जाने वाले प्रश्न",
  faqMetricsQ: "मैं डैशबोर्ड पर अपने वाइटल्स कैसे जाँचूँ?",
  faqMetricsA:
    "साइडबार से डैशबोर्ड खोलें। BP, हृदय गति, ग्लूकोज और SpO₂ के लाइव वाइटल्स मुख्य कार्डों पर चार्ट के साथ दिखते हैं। पूरा इतिहास के लिए वाइटल्स रिपोर्ट पर जाएँ।",
  faqVitalsReportsQ: "मैं अपना वाइटल्स इतिहास और रुझान कहाँ देख सकता हूँ?",
  faqVitalsReportsA:
    "साइडबार से वाइटल्स रिपोर्ट खोलें। ब्लड प्रेशर, हृदय गति, ग्लूकोज और ऑक्सीजन स्तर की पिछली रीडिंग और रुझान की समीक्षा कर सकते हैं।",
  faqAppointmentsQ: "मैं अपॉइंटमेंट कैसे बुक या देखूँ?",
  faqAppointmentsA:
    "अपॉइंटमेंट देखने, बुक या पुनर्निर्धारित करने के लिए साइडबार में कैलेंडर पर जाएँ। क्विक पिक्स → अपॉइंटमेंट से तारा से भी पूछ सकते हैं।",
  faqCoinsQ: "कॉइन और दैनिक मिशन कैसे काम करते हैं?",
  faqCoinsA:
    "लॉगिन और डैशबोर्ड व कॉइन वॉलेट पर दिखाए दैनिक मिशन पूरे करके कॉइन कमाते हैं। रिवार्ड स्ट्रिप में बैलेंस देखें और कॉइन वॉलेट खोलने के लिए रिडीम पर टैप करें।",
  faqAiQ: "मैं तारा चैट और क्विक पिक्स कैसे उपयोग करूँ?",
  faqAiA:
    "नीचे-दाएँ चैट आइकन पर टैप करें। लक्षण जाँच, वाइटल रिपोर्ट, दवा, रिपोर्ट, स्वास्थ्य सारांश, परिवार सदस्य और अपॉइंटमेंट के लिए क्विक पिक्स का उपयोग करें। कभी भी स्वास्थ्य प्रश्न टाइप या बोलें।",
  faqTaraGuideQ: "तारा गाइड साइड पैनल क्या है?",
  faqTaraGuideA:
    "तारा गाइड ऐप के दाईं ओर का पैनल है। यह स्वास्थ्य अलर्ट, तारा संदेश दिखाता है और डैशबोर्ड, दवा, रिपोर्ट व अन्य पेज ब्राउज़ करते समय चैट की सुविधा देता है।",
  faqMyTaraReportsQ: "चिकित्सा रिपोर्ट और MyTara रिपोर्ट में क्या अंतर है?",
  faqMyTaraReportsA:
    "चिकित्सा रिपोर्ट में आपके आधिकारिक स्वास्थ्य रिकॉर्ड और लैब दस्तावेज़ होते हैं। MyTara रिपोर्ट में तारा चैट बातचीत और स्वास्थ्य अंतर्दृष्टि के AI-जनित सारांश होते हैं।",
  faqFamilyQ: "मैं परिवार सदस्य प्रोफ़ाइल कैसे जोड़ूँ या बदलूँ?",
  faqFamilyA:
    "साइडबार से परिवार खोज में सदस्य जोड़ें। हेडर में स्वयं / परिवार सदस्य ड्रॉपडाउन से प्रोफ़ाइल बदलें। प्रत्येक नई प्रोफ़ाइल के लिए स्वास्थ्य प्रश्नावली पूरी करें।",
  faqMedCloudQ: "मैं मेड क्लाउड में दस्तावेज़ कैसे अपलोड करूँ?",
  faqMedCloudA:
    "साइडबार से मेड क्लाउड खोलें, नुस्खे, लैब रिपोर्ट या स्कैन अपलोड करें और कभी भी एक्सेस करें। चैट में AI विश्लेषण के लिए तारा के साथ फ़ाइलें साझा भी कर सकते हैं।",
  faqMedsQ: "दवा रिमाइंडर कैसे काम करते हैं?",
  faqMedsA:
    "दवा पर जाएँ, खुराक समय के साथ नुस्खा जोड़ें और रिमाइंडर सक्षम करें। दवा लेते समय डैशबोर्ड या दवा पेज से खुराक ली हुई चिह्नित करें।",
  faqQuestionnaireQ: "स्वास्थ्य प्रश्नावली क्या है?",
  faqQuestionnaireA:
    "प्रारंभिक स्वास्थ्य प्रश्नावली बुनियादी स्वास्थ्य जानकारी, दवाएँ, पारिवारिक इतिहास और लक्ष्य एकत्र करती है। बेहतर AI व्यक्तिगतकरण के लिए प्रोफ़ाइल या परिवार सदस्य जोड़ते समय इसे पूरा करें।",
  faqChangeCredentialQ: "मैं अपने साइन-इन क्रेडेंशियल कैसे अपडेट करूँ?",
  faqChangeCredentialA:
    "हेडर में अपना प्रोफ़ाइल अवतार क्लिक करें, प्रोफ़ाइल मेनू खोलें और क्रेडेंशियल अपडेट विकल्प चुनें। वर्तमान साइन-इन विवरण दर्ज करें, फिर नए सेट करें।",
  faqHealthInterestsQ: "मैं अपनी स्वास्थ्य रुचियाँ कैसे अपडेट करूँ?",
  faqHealthInterestsA:
    "प्रोफ़ाइल मेनू खोलें और स्वास्थ्य रुचियाँ चुनें। वाइटल्स ट्रैकिंग, दवा रिमाइंडर या AI स्वास्थ्य विश्लेषण जैसे विषय चुनकर सुझाव और डैशबोर्ड सामग्री व्यक्तिगत बनाएँ।",
  faqLanguageThemeQ: "मैं भाषा या लाइट/डार्क थीम कैसे बदलूँ?",
  faqLanguageThemeA:
    "ऐप भाषा बदलने के लिए हेडर में भाषा चयनकर्ता का उपयोग करें। लाइट और डार्क मोड के बीच स्विच करने के लिए थीम टॉगल बटन का उपयोग करें। दोनों सेटिंग्स पूरे ऐप में लागू होती हैं।",
  faqNotificationsQ: "सूचनाएँ कैसे काम करती हैं?",
  faqNotificationsA:
    "स्वास्थ्य अपडेट, अपॉइंटमेंट और ऐप गतिविधि के अलर्ट देखने के लिए हेडर में घंटी आइकन पर टैप करें। खोलने तक अपठित सूचनाएँ हाइलाइट रहती हैं।",
  faqRememberMeQ: "लॉगिन पर रिमेंबर मी क्या करता है?",
  faqRememberMeA:
    "चेक करने पर, रिमेंबर मी सुरक्षित स्टोरेज के माध्यम से ब्राउज़र सत्रों में साइन इन रखता है। इसके बिना, ब्राउज़र बंद करने पर फिर से लॉगिन करना होगा।",
  noResults: "आपकी खोज से कोई सहायता लेख मेल नहीं खाता।",
  seeMoreGuides: "और मार्गदर्शिकाएँ देखें",
  seeMoreFaqs: "और प्रश्न देखें",
  showLess: "कम दिखाएँ",
};

export const PA_HELP_GUIDE = {
  subtitle: "ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਸਵਾਲ • ਸੁਝਾਅ • ਸਹਾਇਤਾ",
  subtitleFaq: "ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਸਵਾਲ",
  subtitleTips: "ਸੁਝਾਅ",
  subtitleSupport: "ਸਹਾਇਤਾ",
  searchPlaceholder: "ਸਹਾਇਤਾ ਲੇਖ ਖੋਜੋ...",
  categoryAll: "ਸਭ",
  categoryDailyHealth: "ਡੈਸ਼ਬੋਰਡ ਅਤੇ ਵਾਈਟਲਜ਼",
  categoryAiAssistant: "ਤਾਰਾ AI ਚੈਟ",
  categorySecurity: "ਰਿਕਾਰਡ ਅਤੇ ਦਵਾਈਆਂ",
  welcomeTitle: "myTara ਸਹਾਇਤਾ ਕੇਂਦਰ ਵਿੱਚ ਜੀ ਆਇਆਂ ਨੂੰ",
  welcomeDesc:
    "ਡੈਸ਼ਬੋਰਡ, ਵਾਈਟਲਜ਼, ਤਾਰਾ AI ਚੈਟ, ਦਵਾਈਆਂ, ਰਿਪੋਰਟਾਂ, ਮੈਡ ਕਲਾਉਡ, ਪਰਿਵਾਰਕ ਪ੍ਰੋਫਾਈਲ, ਸਿੱਕੇ, ਕੈਲੰਡਰ ਅਤੇ ਖਾਤਾ ਸੈਟਿੰਗਾਂ ਲਈ ਪੂਰੀਆਂ ਗਾਈਡਾਂ।",
  seeMoreGuides: "ਹੋਰ ਗਾਈਡਾਂ ਦੇਖੋ",
  seeMoreFaqs: "ਹੋਰ ਸਵਾਲ ਦੇਖੋ",
  showLess: "ਘੱਟ ਦਿਖਾਓ",
  noResults: "ਤੁਹਾਡੀ ਖੋਜ ਨਾਲ ਕੋਈ ਸਹਾਇਤਾ ਲੇਖ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ।",
  faqTitle: "ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਸਵਾਲ",
};

export const TE_HELP_GUIDE = {
  subtitle: "తరచుగా అడిగే ప్రశ్నలు • చిట్కాలు • మద్దతు",
  subtitleFaq: "తరచుగా అడిగే ప్రశ్నలు",
  subtitleTips: "చిట్కాలు",
  subtitleSupport: "మద్దతు",
  searchPlaceholder: "సహాయ వ్యాసాలు వెతకండి...",
  categoryAll: "అన్నీ",
  categoryDailyHealth: "డాష్‌బోర్డ్ & వైటల్స్",
  categoryAiAssistant: "తారా AI చాట్",
  categorySecurity: "రికార్డులు & మందులు",
  welcomeTitle: "myTara సహాయ కేంద్రానికి స్వాగతం",
  welcomeDesc:
    "డాష్‌బోర్డ్, వైటల్స్, తారా AI చాట్, మందులు, రిపోర్టులు, మెడ్ క్లౌడ్, కుటుంబ ప్రొఫైల్‌లు, నాణేలు, క్యాలెండర్ మరియు ఖాతా సెట్టింగ్‌ల కోసం పూర్తి గైడ్‌లు.",
  seeMoreGuides: "మరిన్ని గైడ్‌లు చూడండి",
  seeMoreFaqs: "మరిన్ని ప్రశ్నలు చూడండి",
  showLess: "తక్కువ చూపించు",
  noResults: "మీ శోధనకు సరిపోయే సహాయ వ్యాసాలు లేవు.",
  faqTitle: "తరచుగా అడిగే ప్రశ్నలు",
};

export const TA_HELP_GUIDE = {
  subtitle: "அடிக்கடி கேட்கப்படும் கேள்விகள் • குறிப்புகள் • ஆதரவு",
  subtitleFaq: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
  subtitleTips: "குறிப்புகள்",
  subtitleSupport: "ஆதரவு",
  searchPlaceholder: "உதவி கட்டுரைகளைத் தேடுங்கள்...",
  categoryAll: "அனைத்தும்",
  categoryDailyHealth: "டாஷ்போர்டு & உயிர்ச்சின்னங்கள்",
  categoryAiAssistant: "தாரா AI அரட்டை",
  categorySecurity: "பதிவுகள் & மருந்துகள்",
  welcomeTitle: "myTara உதவி மையத்திற்கு வரவேற்கிறோம்",
  welcomeDesc:
    "டாஷ்போர்டு, உயிர்ச்சின்னங்கள், தாரா AI அரட்டை, மருந்துகள், அறிக்கைகள், மெட் கிளவுட், குடும்ப சுயவிவரங்கள், நாணயங்கள், நாட்காட்டி மற்றும் கணக்கு அமைப்புகளுக்கான முழு வழிகாட்டிகள்.",
  seeMoreGuides: "மேலும் வழிகாட்டிகள்",
  seeMoreFaqs: "மேலும் கேள்விகள்",
  showLess: "குறைவாகக் காட்டு",
  noResults: "உங்கள் தேடலுக்குப் பொருந்தும் உதவி கட்டுரைகள் இல்லை.",
  faqTitle: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
};

export const MR_HELP_GUIDE = {
  subtitle: "वारंवार विचारले जाणारे प्रश्न • टिप्स • समर्थन",
  subtitleFaq: "वारंवार विचारले जाणारे प्रश्न",
  subtitleTips: "टिप्स",
  subtitleSupport: "समर्थन",
  searchPlaceholder: "मदत लेख शोधा...",
  categoryAll: "सर्व",
  categoryDailyHealth: "डॅशबोर्ड आणि व्हायटल्स",
  categoryAiAssistant: "तारा AI चॅट",
  categorySecurity: "रेकॉर्ड आणि औषधे",
  welcomeTitle: "myTara मदत केंद्रात आपले स्वागत आहे",
  welcomeDesc:
    "डॅशबोर्ड, व्हायटल्स, तारा AI चॅट, औषधे, अहवाल, मेड क्लाउड, कुटुंब प्रोफाइल, कॉइन, कॅलेंडर आणि खाते सेटिंग्ससाठी संपूर्ण मार्गदर्शक.",
  seeMoreGuides: "अधिक मार्गदर्शक पहा",
  seeMoreFaqs: "अधिक प्रश्न पहा",
  showLess: "कमी दाखवा",
  noResults: "तुमच्या शोधाशी जुळणारे मदत लेख नाहीत.",
  faqTitle: "वारंवार विचारले जाणारे प्रश्न",
};

export const BN_HELP_GUIDE = {
  subtitle: "প্রায়শই জিজ্ঞাসিত প্রশ্ন • টিপস • সহায়তা",
  subtitleFaq: "প্রায়শই জিজ্ঞাসিত প্রশ্ন",
  subtitleTips: "টিপস",
  subtitleSupport: "সহায়তা",
  searchPlaceholder: "সহায়তা নিবন্ধ খুঁজুন...",
  categoryAll: "সব",
  categoryDailyHealth: "ড্যাশবোর্ড ও ভাইটালস",
  categoryAiAssistant: "তারা AI চ্যাট",
  categorySecurity: "রেকর্ড ও ওষুধ",
  welcomeTitle: "myTara সহায়তা কেন্দ্রে স্বাগতম",
  welcomeDesc:
    "ড্যাশবোর্ড, ভাইটালস, তারা AI চ্যাট, ওষুধ, রিপোর্ট, মেড ক্লাউড, পরিবার প্রোফাইল, কয়েন, ক্যালেন্ডার ও অ্যাকাউন্ট সেটিংসের সম্পূর্ণ গাইড।",
  seeMoreGuides: "আরও গাইড দেখুন",
  seeMoreFaqs: "আরও প্রশ্ন দেখুন",
  showLess: "কম দেখান",
  noResults: "আপনার অনুসন্ধানের সাথে মিলে এমন কোনো সহায়তা নিবন্ধ নেই।",
  faqTitle: "প্রায়শই জিজ্ঞাসিত প্রশ্ন",
};

export const KN_HELP_GUIDE = {
  subtitle: "ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು • ಸಲಹೆಗಳು • ಬೆಂಬಲ",
  subtitleFaq: "ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು",
  subtitleTips: "ಸಲಹೆಗಳು",
  subtitleSupport: "ಬೆಂಬಲ",
  searchPlaceholder: "ಸಹಾಯ ಲೇಖನಗಳನ್ನು ಹುಡುಕಿ...",
  categoryAll: "ಎಲ್ಲಾ",
  categoryDailyHealth: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ಮತ್ತು ವೈಟಲ್ಸ್",
  categoryAiAssistant: "ತಾರಾ AI ಚಾಟ್",
  categorySecurity: "ದಾಖಲೆಗಳು ಮತ್ತು ಔಷಧಿಗಳು",
  welcomeTitle: "myTara ಸಹಾಯ ಕೇಂದ್ರಕ್ಕೆ ಸ್ವಾಗತ",
  welcomeDesc:
    "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್, ವೈಟಲ್ಸ್, ತಾರಾ AI ಚಾಟ್, ಔಷಧಿಗಳು, ವರದಿಗಳು, ಮೆಡ್ ಕ್ಲೌಡ್, ಕುಟುಂಬ ಪ್ರೊಫೈಲ್‌ಗಳು, ನಾಣ್ಯಗಳು, ಕ್ಯಾಲೆಂಡರ್ ಮತ್ತು ಖಾತೆ ಸೆಟ್ಟಿಂಗ್‌ಗಳಿಗೆ ಸಂಪೂರ್ಣ ಮಾರ್ಗದರ್ಶಿಗಳು.",
  seeMoreGuides: "ಹೆಚ್ಚು ಮಾರ್ಗದರ್ಶಿಗಳನ್ನು ನೋಡಿ",
  seeMoreFaqs: "ಹೆಚ್ಚು ಪ್ರಶ್ನೆಗಳನ್ನು ನೋಡಿ",
  showLess: "ಕಡಿಮೆ ತೋರಿಸಿ",
  noResults: "ನಿಮ್ಮ ಹುಡುಕಾಟಕ್ಕೆ ಹೊಂದಿಕೆಯಾಗುವ ಸಹಾಯ ಲೇಖನಗಳಿಲ್ಲ.",
  faqTitle: "ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು",
};

const HELP_GUIDE_LOCALE_BLOCKS = {
  pa: PA_HELP_GUIDE,
  te: TE_HELP_GUIDE,
  ta: TA_HELP_GUIDE,
  mr: MR_HELP_GUIDE,
  bn: BN_HELP_GUIDE,
  kn: KN_HELP_GUIDE,
};

export const applyHelpGuideLocaleBlocks = (translations) => {
  const enBase = translations.en?.helpGuide;
  if (!enBase) return;

  if (translations.hi) {
    translations.hi.helpGuide = { ...enBase, ...HI_HELP_GUIDE };
    if (translations.hi.common) {
      translations.hi.common.helpGuide = HELP_GUIDE_COMMON_LABELS.hi;
    }
  }

  Object.entries(HELP_GUIDE_LOCALE_BLOCKS).forEach(([lang, block]) => {
    if (!translations[lang]) return;
    translations[lang].helpGuide = { ...enBase, ...block };
    if (translations[lang].common && HELP_GUIDE_COMMON_LABELS[lang]) {
      translations[lang].common.helpGuide = HELP_GUIDE_COMMON_LABELS[lang];
    }
  });
};
